import { render, staticRenderFns } from "./inBox.vue?vue&type=template&id=38e2828c&scoped=true"
import script from "./inBox.vue?vue&type=script&lang=js"
export * from "./inBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e2828c",
  null
  
)

export default component.exports